import api from "@/services/api";

export const removeCoupon = async (orderFormId: string) => {
  const { data } = await api.delete(`/checkout/cart/${orderFormId}/coupons`);
  return data;
};

export const addCoupon = async (orderFormId: string, coupon: string) => {
  const payload = { text: coupon };
  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/coupons`,
    payload
  );
  return data;
};
